import { IMatchChangeHpTemplate, IMatchChangeHp } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidMatchChangeHpQuery } from './typeguards';
import { CreateMatchChangeInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { MatchChangeHpQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: MatchChangeHpQuery): IMatchChangeHpTemplate=> {
  if (isValidMatchChangeHpQuery(obj)) {
    CreateMatchChangeInputSchema().parse(obj.data.getMatchChange, {reportInput: true});

    const { matchList } = obj?.data?.getMatchChange;
    const transformedMatchList: IMatchChangeHp[] = (matchList!)
      .filter(Boolean)
      .map((match) => {
        const m = match as IMatchChangeHp;

        const awayTeam = m.away as IMatchChangeHp['away'] & { negativeLogoUrl?: string };
        const homeTeam = m.home as IMatchChangeHp['home'] & { negativeLogoUrl?: string };

        return {
          ...m,
          away: {
            id: awayTeam.id,
            goal: awayTeam.goal,
            name: awayTeam.name,
            logoUrl: awayTeam.negativeLogoUrl ?? awayTeam.logoUrl,
            overtimeGoal: awayTeam.overtimeGoal,
            shootoutGoal: awayTeam.shootoutGoal,
            totalGoalLegs: awayTeam.totalGoalLegs,
            regularTimeGoal: typeof awayTeam.goal === 'number' ? awayTeam.goal : undefined,
          },
          home: {
            id: homeTeam.id,
            goal: homeTeam.goal,
            name: homeTeam.name,
            logoUrl: homeTeam.negativeLogoUrl ?? homeTeam.logoUrl,
            overtimeGoal: homeTeam.overtimeGoal,
            shootoutGoal: homeTeam.shootoutGoal,
            totalGoalLegs: homeTeam.totalGoalLegs,
            regularTimeGoal: typeof homeTeam.goal === 'number' ? homeTeam.goal : undefined,
          },
        } as IMatchChangeHp;
      });

    return {
      matchList: transformedMatchList,
      trackingData: intcmpMap.matchChangeHp
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchChangeHpQuery object',
      data: obj
    });
  }
};
